import React, { FC, memo } from 'react';

import IconPlus from '@zvuk-b2b/react-uikit/ui/icons/Plus';

import { DATA_TEST_IDS } from '../consts';
import { TEXTS } from '../texts';
import type { AddExternalRecipientsButtonProps } from './types';

import styles from './index.module.scss';

const AddExternalRecipientsButton: FC<AddExternalRecipientsButtonProps> = ({ onClick }) => (
  <button
    type="button"
    className={styles.button}
    data-testid={DATA_TEST_IDS.ADD_EXTERNAL_RECIPIENTS_BUTTON}
    onClick={onClick}>
    <IconPlus className={styles.icon} />
    <span data-testid={DATA_TEST_IDS.ADD_EXTERNAL_RECIPIENTS_TEXT}>{TEXTS.ADD_EXTERNAL_RECIPIENTS}</span>
  </button>
);

export default memo(AddExternalRecipientsButton);
